"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toolbar = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const React = tslib_1.__importStar(require("react"));
const styled_tools_1 = require("styled-tools");
const Box_1 = require("./Box");
const utils_1 = require("./utils");
const ToolbarComponent = (props) => (React.createElement(Box_1.Box, Object.assign({ "aria-orientation": props.vertical ? 'vertical' : 'horizontal' }, props)));
exports.Toolbar = styled_1.default(ToolbarComponent) `
  position: relative;
  display: grid;
  width: 100%;
  padding: ${styled_tools_1.withProp('gutter', utils_1.numberToPx)};
  grid-gap: ${styled_tools_1.withProp('gutter', utils_1.numberToPx)};
  grid-template:
    'start center end'
    / 1fr auto 1fr;

  &[aria-orientation='vertical'] {
    width: min-content;
    height: 100%;
    grid-template:
      'start' 1fr
      'center' auto
      'end' 1fr;
  }

  ${styled_tools_1.theme('Toolbar')};
`;
exports.Toolbar.defaultProps = {
    role: 'toolbar',
    gutter: 8,
};

//# sourceMappingURL=Toolbar.js.map
